export default "__VITE_ASSET__6J46ecac__"